import {
  Box,
  ButtonV3,
  GridItem,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import { POP_PATHNAME } from '@/app/consts/pathnames';
import useOuraGen4Enabled from '@/app/hooks/useOuraGen4Enabled';

const MembershipBetterSleep = (): JSX.Element => {
  const t = useTranslations();
  const pathname = usePathname();
  //TODO: GROW-1607 clean up Gen3 clean up
  const OR4Enabled = useOuraGen4Enabled();

  return (
    <LayoutGrid data-cy="membership-better-sleep">
      <GridItem
        colStart={{ sm: 'full', lg: 'full' }}
        colEnd={{ sm: 'full', lg: 'full' }}
        className="relative"
      >
        <div className="relative aspect-[3200/1111] w-full">
          <ArtDirectionImage
            srcSet={[
              {
                src: OR4Enabled
                  ? 'membership/membership-buy-cta-hero-mobile'
                  : 'meet-the-community/better-sleep-alt',
                media: '(max-width: 767px)',
              },
              {
                src: OR4Enabled
                  ? 'membership/membership-buy-cta-hero'
                  : 'meet-the-community/better-sleep',
                media: '(min-width: 768px)',
              },
            ]}
            alt={t('membership_better_sleep_alt')}
            sizes="100vw"
            fill
            className="object-cover"
          />
          <Box className="relative max-w-[1158px]">
            <div className="pb-[410px] pt-20 md:max-w-sm md:py-40 lg:max-w-md lg:py-48 xl:max-w-xl">
              <TypographyV3
                variant="h2"
                Element="h2"
                className="text-4xl text-sandstone-100 md:text-6xl"
                data-cy="better_sleep_banner_title"
              >
                {t.rich('better_sleep_banner_title')}
              </TypographyV3>
              <Link
                href={POP_PATHNAME}
                onClick={async () => {
                  await window.ouraAnalytics.track(EventType.CTAClicked, {
                    cta: 'Buy Oura Ring',
                    location: 'Better Sleep Banner',
                    path: pathname,
                  });
                }}
                passHref
              >
                <ButtonV3
                  variant="primary"
                  className="mt-6"
                  data-cy="better_sleep_banner_cta"
                >
                  {t('better_sleep_banner_cta')}
                </ButtonV3>
              </Link>
            </div>
          </Box>
        </div>
      </GridItem>
    </LayoutGrid>
  );
};

export default MembershipBetterSleep;
